import { useRouteError } from "react-router-dom";
import CustomErrorFallback from "@/components/common/Oops";
import type { CustomAxiosError } from "@/lib/axios";
import type { AxiosRequestConfig } from "axios";

// CustomAxiosErrorの型ガード
function isCustomAxiosError(error: unknown): error is CustomAxiosError {
  if (!error || typeof error !== "object") return false;
  const err = error as Record<string, unknown>;
  return (
    ("isAxiosError" in err && err["isAxiosError"] === true) ||
    (typeof err["message"] === "string" &&
      typeof err["name"] === "string" &&
      typeof err["config"] === "object" &&
      typeof err["response"] === "object")
  );
}

export function RouterErrorFallback() {
  const routeError = useRouteError();

  let errorForFallback: CustomAxiosError;

  if (isCustomAxiosError(routeError)) {
    errorForFallback = routeError;
  } else {
    const message =
      routeError instanceof Error
        ? routeError.message
        : typeof routeError === "string"
        ? routeError
        : "An unknown error occurred";
    const name = routeError instanceof Error ? routeError.name : "Error";

    errorForFallback = {
      isAxiosError: false,
      name,
      message,
      config: {} as AxiosRequestConfig,
      response: undefined,
      data: undefined,
      status: undefined as number | undefined,
      statusText: undefined,
      headers: undefined,
      toJSON: () => Object.create(null),
    } as unknown as CustomAxiosError;
  }

  return <CustomErrorFallback error={errorForFallback} />;
}
